import { useMemo } from 'react';

import { getHttpStatus } from '@kc-console/core';

import { EMPTY_STATE } from '../EmptyState/types';

import type { EmptyStateType } from '../EmptyState';

interface UseDataTableStatusProps {
  hasFilters: boolean;
  rowsLength: number;
  error?: unknown;
  isError?: boolean;
  isLoading?: boolean;
}

const getDataEmptyStateType = (params: {
  hasFilters: boolean;
  rowsLength: number;
}): EmptyStateType | null => {
  const { rowsLength, hasFilters } = params;

  if (rowsLength === 0) {
    return hasFilters ? EMPTY_STATE.SEARCH : EMPTY_STATE.LIST;
  }

  return null;
};

export default function useDataTableStatus({
  isLoading,
  isError,
  error,
  rowsLength,
  hasFilters,
}: UseDataTableStatusProps) {
  const errorStatus = useMemo(() => getHttpStatus(error), [error]);

  const dataEmptyStateType = useMemo(
    () => getDataEmptyStateType({ rowsLength, hasFilters }),
    [rowsLength, hasFilters],
  );

  const emptyStateType = useMemo<EmptyStateType | null>(() => {
    if (isLoading) return EMPTY_STATE.LOADING;

    if (isError) return EMPTY_STATE.WARNING;

    return dataEmptyStateType;
  }, [isLoading, isError, dataEmptyStateType]);

  return {
    dataEmptyStateType,
    emptyStateType,
    errorStatus,
  };
}
